import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeItemsfromOrder } from "api/order";

import InitialMessage from "shared/product_tabs/cart/components/InitialMessage";
import Parts from "shared/product_tabs/cart/components/Parts";
import Assembly from "shared/product_tabs/cart/components/Assembly";

import { validate as partsValidate } from "shared/product_tabs/tab_parts/bomSlice";
import { validate as assemblyValidate, projectValidator, updateValidatorFlag } from "product_tabs/tab_assembly/assemblySlice";
import { buildForms as buildBomForms } from "product_tabs/tab_parts/utils/builders";
import { buildForms as buildAssemblyForms } from "product_tabs/tab_assembly/utils/builders";
import { selectDataForCart } from "us_pcb_assembly/cart/selectors";
import { showErrors } from "shared/product_tabs/alerts/alertSlice";
import { orderProduct } from "api/order";
import { buildProjectNumber } from "product_tabs/cart/utils/builders";

const Cart = () => {
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();
  let total = 0;

  const { parts, assembly } = useSelector(selectDataForCart);

  const { partDataForForms, partProps, partToDestroy } = parts;
  const { assemblyDataForForms, assemblyProps, assemblyToDestroy } = assembly;

  const projectNumber = () => {
    const { currentVariant } = assemblyProps;
    return Spree.project_number || buildProjectNumber(`PU${currentVariant}`, 24)
  }

  const projectReference = () => 'usa-pcb-assembly';

  const onAddToCart = async () => {
    // Delete products marked as destroy
    const lineItems = [
      ...assemblyToDestroy,
      ...partToDestroy,
    ];

    if (lineItems && lineItems.length > 0) {
      try {
        await removeItemsfromOrder(lineItems);
      } catch (err) {
        console.error(err);
      }
    }

    const project_number = projectNumber();
    const project_reference = projectReference();

    const forms = [
      ...buildAssemblyForms({
        ...assemblyDataForForms,
        project_number,
        project_reference,
      }),
      ...buildBomForms({
        ...partDataForForms,
        project_number,
        project_reference,
      }),
    ];

    for (const form of forms) {
      try {
        await orderProduct(form);
      } catch (err) {
        console.error(err);
      }
    }

    window.location.href = "/cart";
  };

  const onItemsValidate = () => {
    if (total <= 0) {
      dispatch(showErrors("Please select some product before add to cart."));
      return false;
    }
    return true;
  };

  const onProjectValidate = () => {
    let validateResult = true;

    if (!projectValidator.allValid()) {
      projectValidator.showMessages();
      let errors = projectValidator.getErrorMessages();
      let foundErrors = [];
      if(errors['Part Number'] && errors['Part Number'] != "") foundErrors.push('Please enter the part number (board name or project name) for your project.');
      if(errors['Revision'] && errors['Revision'] != "") foundErrors.push('Please enter your revision.');
      if(errors['Zip file'] && errors['Zip file'] != "") foundErrors.push('Please upload your Zip File');
      dispatch(showErrors(foundErrors));
      dispatch(updateValidatorFlag());
      validateResult = false;
      setTimeout(() => {
        document.querySelector('.project-information .srv-validation-message').scrollIntoView(false);
      }, 500);
    }

    return validateResult;
  }

  const onClick = () => {
    setSaving(true);

    let validationResult = true;
    validationResult = dispatch(assemblyValidate(validationResult)) && validationResult;
    validationResult = dispatch(partsValidate(validationResult)) && validationResult;
    validationResult = onProjectValidate() && validationResult;
    validationResult = onItemsValidate() && validationResult;

    if (!validationResult) {
      setSaving(false);
      return;
    }

    onAddToCart();
  };

  [partProps, assemblyProps].forEach(
    (data) => {
      if (data.selected) {
        total += parseFloat(data.subTotal);
      }
    }
  );

  return (
    <div className="inside-product-cart">
      <div className="mb-1 selection-label">Order Summary:</div>
      <InitialMessage selected={partProps.selected || assemblyProps.selected} />
      <Assembly {...assemblyProps} />
      <Parts {...partProps} />
      <hr />
      <div className="sub-total">SUBTOTAL: ${accounting.toFixed(total, 2)}</div>
      <button
        type="button"
        className="btn btn-main-action w-100"
        onClick={onClick}
        disabled={saving}>
        {saving && (
          <span
            className="spinner-border spinner-border-sm mr-1"
            aria-hidden="true"
          />
        )}
        {saving ? "ADDING..." : "ADD TO CART"}
      </button>
    </div>
  );
};

export default Cart;
